import axiosInstance from "config/axios-config.js";

// Save student's attendance
export const postattendance = async (data, isClass = false) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  const payload = isClass ? data : { attendances: data };
  try {
    const result = await axiosInstance.post("/attendance", payload);
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Attendance posted successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while posting attendance. Please try again.";
    }
  } catch (error) {
    // No response means the request never reached the server
    response.networkError = !error.response;
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while posting attendance. Please check your connection and try again.";
  }
  return response;
};

// Get Student Attendance Detail
export const getStudentAttendanceDetail = async ({
  student_id,
  semesterId = "",
  academicYearId = "",
}) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  const params = {};
  if (semesterId) {
    params.semester_id = semesterId;
  }
  if (academicYearId) {
    params.academic_year = academicYearId;
  }
  try {
    const result = await axiosInstance.get(`/attendance/student/${student_id}`, { params });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Student attendance retrieved successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while retrieving student attendance. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while retrieving student attendance. Please check your connection and try again.";
  }
  return response;
};

// Get Class Attendance
export const getAttendanceByClass = async ({ semesterId = "", academicYearId = "" } = {}) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  const params = {};
  if (semesterId) {
    params.semester_id = semesterId;
  }
  if (academicYearId) {
    params.academic_year = academicYearId;
  }
  try {
    const result = await axiosInstance.get(`/attendance/class`, { params });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Class attendance retrieved successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while retrieving class attendance. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while retrieving class attendance. Please check your connection and try again.";
  }
  return response;
};

// Get Frequently Absent Students
export const getFrequentAbsent = async () => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.get(`/attendance/frequently-absent-students`);
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message =
        result.data?.message ?? "Frequently absent students retrieved successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while retrieving frequently absent students. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while retrieving frequently absent students. Please check your connection and try again.";
  }
  return response;
};

// Change frequently absent students status
export const changeStatus = async (summary_id, status) => {
  let response = {
    success: false,
    message: "",
  };
  try {
    const result = await axiosInstance.put(`/attendance/absence/update-status/${summary_id}`, {
      status: status,
    });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Status changed successfully";
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while changing the status. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while changing the status. Please check your connection and try again.";
  }
  return response;
};

// Notify Parent
export const notifyParent = async (data) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.post(
      "/attendance/notify-parent-frequently-absent-students",
      data,
    );
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Parent notified successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while notifying the parent. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while notifying the parent. Please check your connection and try again.";
  }
  return response;
};

//for library attendance
export const postLibraryAttendance = async (data) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.post("/library", {
      student_id: data.student_id,
      timeIn: data.timeIn,
      timeOut: null,
    });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Library attendance posted successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while posting library attendance. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while posting library attendance. Please check your connection and try again.";
  }
  return response;
};

//update the library attendace
export const updateLibraryAttendance = async (id, timeOut) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.put(`/library/${id}`, { timeOut });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Library attendance updated successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while updating library attendance. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while updating library attendance. Please check your connection and try again.";
  }
  return response;
};

//for student daily library attendace is not out
export const getDailyStudentAttendaceOffLibrary = async () => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.get("/library/student");
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Library attendance retrieved successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while retrieving library attendance. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while retrieving library attendance. Please check your connection and try again.";
  }
  return response;
};

// Library Attendance Report
export const getLibraryAttendanceReport = async ({ student_id, startDate }) => {
  let response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const result = await axiosInstance.get(`/library/history/${student_id}`, {
      params: { startDate },
    });
    if (result?.data?.success) {
      response.success = result.data.success;
      response.message = result.data?.message ?? "Library attendance report retrieved successfully";
      response.data = result.data?.data ?? null;
    } else {
      response.message =
        result?.data?.message ??
        "An unexpected error occurred while retrieving the library attendance report. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while retrieving the library attendance report. Please check your connection and try again.";
  }
  return response;
};

// Download detailed attendance data as a file
export const downloadDetailedAttendance = async (query) => {
  let response = {
    success: false,
    message: "",
    data: null,
    headers: null,
  };
  try {
    const result = await axiosInstance.get("/attendance/download", {
      params: query,
      responseType: "blob",
    });
    if (result?.status === 200 && result?.data) {
      response.success = true;
      response.message = "Attendance data downloaded successfully.";
      response.data = result.data;
      response.headers = result.headers;
    } else {
      response.message =
        "An unexpected error occurred while downloading attendance data. Please try again.";
    }
  } catch (error) {
    response.message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while downloading attendance data. Please check your connection and try again.";
  }
  return response;
};
